export const linkedinColored = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11_241)">
      <path
        d="M20.5236 2.22998H3.47639C3.08483 2.22998 2.7093 2.38553 2.43242 2.66241C2.15555 2.93928 2 3.31481 2 3.70637V20.7536C2 21.1452 2.15555 21.5207 2.43242 21.7976C2.7093 22.0744 3.08483 22.23 3.47639 22.23H20.5236C20.9152 22.23 21.2907 22.0744 21.5676 21.7976C21.8445 21.5207 22 21.1452 22 20.7536V3.70637C22 3.31481 21.8445 2.93928 21.5676 2.66241C21.2907 2.38553 20.9152 2.22998 20.5236 2.22998ZM7.96111 19.2675H4.95417V9.71609H7.96111V19.2675ZM6.45556 8.39248C6.11447 8.39056 5.7816 8.28764 5.49895 8.09672C5.21629 7.9058 4.99653 7.63542 4.8674 7.31972C4.73826 7.00402 4.70554 6.65714 4.77336 6.32286C4.84118 5.98858 5.0065 5.68188 5.24846 5.44146C5.49042 5.20105 5.79818 5.0377 6.13289 4.97203C6.4676 4.90636 6.81426 4.94131 7.12913 5.07247C7.44399 5.20363 7.71295 5.42512 7.90205 5.70899C8.09116 5.99286 8.19194 6.32639 8.19167 6.66748C8.19488 6.89584 8.15209 7.12251 8.06584 7.33398C7.97959 7.54545 7.85165 7.7374 7.68964 7.89837C7.52763 8.05934 7.33487 8.18605 7.12285 8.27094C6.91083 8.35583 6.68389 8.39716 6.45556 8.39248ZM19.0444 19.2758H16.0389V14.0578C16.0389 12.5189 15.3847 12.0439 14.5403 12.0439C13.6486 12.0439 12.7736 12.7161 12.7736 14.0966V19.2758H9.76667V9.72304H12.6583V11.0466H12.6972C12.9875 10.4591 14.0042 9.45498 15.5556 9.45498C17.2333 9.45498 19.0458 10.4508 19.0458 13.3675L19.0444 19.2758Z"
        fill="#0A66C2"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_241">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(2 2.22998)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default linkedinColored;
